import { organisationConstants } from '../../_constants/organisation.constants';
import { organisationService } from '../../_services/organisation.service';

import { organisationAction } from '../organisation.action';

export const manageBatchActions = {
    updateMandateGroupAction,
    clearAddParticipentsState,
    getBatchList,
    addBatchAction,
    deleteBatchAction,
    detailedBatchAction,
    getAllotedUnallotedListAction,
    updateMinResAction,
    getParticipantsListAction,
    addParticipentsAction,
    disablePiAction,
    enablePiAction,
    addOrgMandate,
    allotBatchesAction,
    removeFromBatchAction,
    enableReportsAction,
    disableReportsAction,
    setExpiryDateAction,
    setReportThemeAction,
    deleteReportsAction,
    unsubmittedAssessmentAction,
    resetAssessmentAction,
    getThemeReportAction,
    allotAssessmentInstrumentListAction,
    allotAssessParticipantAction,
    setDevelopmentAction,
    getCustomReportAction,
    setReportCustom,
    addAnalyticsAction,
    removeAnalyticsAction
};

function getBatchList(data) {
    return dispatch => {
        dispatch(request());

        organisationService.getBatchData(data)
            .then(
                get_batch_list => {
                    dispatch(success(get_batch_list));
                    dispatch(organisationAction.setIds({
                        orgId: data.orgId,
                        sellerId: data.sellerId
                    }));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(organisationAction.setIds({
                        orgId: data.orgId,
                        sellerId: data.sellerId
                    }));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_BATCH_LIST_ORG } }
    function success(get_batch_list) { return { type: organisationConstants.RECEIVE_BATCH_LIST_ORG, get_batch_list: get_batch_list } }
    function failure(error) { return { type: organisationConstants.ERROR_BATCH_LIST_ORG, error } }
}
function clearAddParticipentsState() {
    return { type: organisationConstants.CLEAR_ADD_PARTICIPENTS };
}



function addOrgMandate(data) {
    return dispatch => {
        dispatch(request());
        organisationService.getOrganizationMandate(data)
            .then(
                add_org_mandate => {
                    dispatch(success(add_org_mandate));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_ORG_MANDATE } }
    function success(add_org_mandate_org) { return { type: organisationConstants.RESPONSE_ORG_MANDATE, add_org_mandate: add_org_mandate_org } }
    function failure(error) { return { type: organisationConstants.ERROR_ORG_MANDATE, error } }
}

function addBatchAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.addBatch(data)
            .then(
                add_batch => {
                    dispatch(success(add_batch));
                    dispatch(getBatchList(data))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_ADD_BATCH_ORG } }
    function success(add_batch_org) { return { type: organisationConstants.RECIEVE_ADD_BATCH_ORG, add_batch: add_batch_org } }
    function failure(error) { return { type: organisationConstants.ERROR_ADD_BATCH_ORG, error } }
}

function deleteBatchAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.deleteBatch(data)
            .then(
                delete_batch => {
                    dispatch(success(delete_batch));
                    dispatch(getBatchList(data));
                    dispatch(getAllotedUnallotedListAction({
                        data: {
                            batch_id: null,
                            organisation_id: data.orgId
                        }
                    }))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_DELETE_BATCH_ORG } }
    function success(delete_batch_org) { return { type: organisationConstants.RECIEVE_DELETE_BATCH_ORG, delete_batch: delete_batch_org } }
    function failure(error) { return { type: organisationConstants.ERROR_DELETE_BATCH_ORG, error } }
}

function getAllotedUnallotedListAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.getAllotedUnallotedList(data)
            .then(
                alloted_unalloted_list => {
                    dispatch(success(alloted_unalloted_list));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_ALLOTED_UNALLOTED_DETAILS } }
    function success(alloted_unalloted_list_org) { return { type: organisationConstants.RECIEVE_ALLOTED_UNALLOTED_DETAILS, alloted_unalloted_list: alloted_unalloted_list_org } }
    function failure(error) { return { type: organisationConstants.ERROR_ALLOTED_UNALLOTED_DETAILS, error } }
}

function detailedBatchAction(orgId, batchId) {
    return dispatch => {
        dispatch(request());
        organisationService.getBatchDetails(orgId, batchId)
            .then(
                batch_details => {
                    dispatch(success(batch_details));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_BATCH_DETAILS } }
    function success(batch_details_org) { return { type: organisationConstants.RECIEVE_BATCH_DETAILS, batch_details: batch_details_org } }
    function failure(error) { return { type: organisationConstants.ERROR_BATCH_DETAILS, error } }
}

function updateMinResAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.updateMinimumRespondance(data)
            .then(
                update_min_res => {
                    dispatch(success(update_min_res));
                    dispatch(detailedBatchAction(data.orgId, data.linkId))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_UPDATE_MIN_RES } }
    function success(update_min_res_org) { return { type: organisationConstants.RECEIVE_UPDATE_MIN_RES, update_min_res: update_min_res_org } }
    function failure(error) { return { type: organisationConstants.ERROR_UPDATE_MIN_RES, error } }
}

function updateMandateGroupAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.updateMandateGroupAction(data)
            .then(
                updated_mandate => {
                    dispatch(success(updated_mandate));
                    dispatch(detailedBatchAction(data.orgId, data.batchId))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_GROUP_MANDATE_UPDATE } }
    function success(updated_mandate) { return { type: organisationConstants.RESPONSE_GROUP_MANDATE_UPDATE, updated_mandate: updated_mandate } }
    function failure(error) { return { type: organisationConstants.ERROR_GROUP_MANDATE_UPDATE, error } }
}

function getParticipantsListAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.getParticipent(data)
            .then(
                participant_list => {
                    dispatch(success(participant_list));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_PARTICIPANTS_LIST } }
    function success(participant_list_org) { return { type: organisationConstants.RESPONSE_PARTICIPANTS_LIST, participant_list: participant_list_org } }
    function failure(error) { return { type: organisationConstants.ERROR_PARTICIPANTS_LIST, error } }
}




function addParticipentsAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.addParticipants(data)
            .then(
                add_par => {
                    dispatch(success(add_par));
                    dispatch(getParticipantsListAction(data))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_ADD_PARTICIPENTS } }
    function success(add_par) { return { type: organisationConstants.RESPONSE_ADD_PARTICIPENTS, add_par: add_par } }
    function failure(error) { return { type: organisationConstants.ERROR_ADD_PARTICIPENTS, error } }
}

function allotAssessmentInstrumentListAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.getInstrumentList(data)
            .then(
                instrument_list => {
                    dispatch(success(instrument_list));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_INSTRUMENT_LIST } }
    function success(instrument_list) { return { type: organisationConstants.RESPONSE_INSTRUMENT_LIST, instrument_list: instrument_list } }
    function failure(error) { return { type: organisationConstants.ERROR_INSTRUMENT_LIST, error } }
}

function allotAssessParticipantAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.allotAssessmentParticipant(data.apiData)
            .then(
                allot_asse => {
                    dispatch(success(allot_asse));
                    dispatch(getParticipantsListAction(data.getParticipants))
                    dispatch(allotAssessmentInstrumentListAction(data.getParticipants))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_All_ASSESSMENT } }
    function success(allot_asse_org) { return { type: organisationConstants.RESPONSE_All_ASSESSMENT, allot_asse: allot_asse_org } }
    function failure(error) { return { type: organisationConstants.ERROR_All_ASSESSMENT, error } }
}

function enablePiAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.enablePI(data)
            .then(
                enable_pi => {
                    dispatch(success(enable_pi));
                    dispatch(getParticipantsListAction(data))
                },
                error => {
                    dispatch(failure(error));
                    dispatch(getParticipantsListAction(data))
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_ENABLE_PI } }
    function success(enable_pi_org) { return { type: organisationConstants.RESPONSE_ENABLE_PI, enable_pi: enable_pi_org } }
    function failure(error) { return { type: organisationConstants.ERROR_ENABLE_PI, error } }
}

function disablePiAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.disablePI(data)
            .then(
                disable_pi => {
                    dispatch(success(disable_pi));
                    dispatch(getParticipantsListAction(data))
                },
                error => {
                    dispatch(failure(error));
                    dispatch(getParticipantsListAction(data))
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_DISABLE_PI } }
    function success(disable_pi_org) { return { type: organisationConstants.RESPONSE_DISABLE_PI, disable_pi: disable_pi_org } }
    function failure(error) { return { type: organisationConstants.ERROR_DISABLE_PI, error } }
}

//Mangae batch unalloted

function allotBatchesAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.allotBatches(data)
            .then(
                allot_batches => {
                    dispatch(success(allot_batches));
                    dispatch(manageBatchActions.getBatchList({
                        orgId: data.orgId,
                        sellerId: data.sellerId,
                    }))
                    dispatch(getAllotedUnallotedListAction({
                        data: {
                            batch_id: null,
                            organisation_id: data.orgId
                        }
                    }))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_ALLOT_BATCH } }
    function success(allot_batches) { return { type: organisationConstants.RESPONSE_ALLOT_BATCH, allot_batches: allot_batches } }
    function failure(error) { return { type: organisationConstants.ERROR_ALLOT_BATCH, error } }
}

function removeFromBatchAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.removeFromBatch(data)
            .then(
                remove_from_batch => {
                    dispatch(success(remove_from_batch));
                    dispatch(getAllotedUnallotedListAction({
                        data: {
                            batch_id: data.batchId,
                            organisation_id: data.orgId
                        }
                    }))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_REMOVE_FROM_BATCH } }
    function success(remove_from_batch) { return { type: organisationConstants.RESPONSE_REMOVE_FROM_BATCH, remove_from_batch: remove_from_batch } }
    function failure(error) { return { type: organisationConstants.ERROR_REMOVE_FROM_BATCH, error } }
}

function setExpiryDateAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.setExpiryDate(data)
            .then(
                set_expiry => {
                    dispatch(success(set_expiry));
                    dispatch(getAllotedUnallotedListAction({
                        data: {
                            batch_id: data.batchId,
                            organisation_id: data.orgId
                        }
                    }))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_SET_EXPIRY } }
    function success(set_expiry) { return { type: organisationConstants.RESPONSE_SET_EXPIRY, set_expiry: set_expiry } }
    function failure(error) { return { type: organisationConstants.ERROR_SET_EXPIRY, error } }
}

function unsubmittedAssessmentAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.unsubmittedAssessment(data)
            .then(
                unsub_assess => {
                    dispatch(success(unsub_assess));
                    dispatch(getAllotedUnallotedListAction({
                        data: {
                            batch_id: data.batchId,
                            organisation_id: data.orgId
                        }
                    }))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_UNSUBMITTED_ASSESSMENT } }
    function success(unsub_assess) { return { type: organisationConstants.RESPONSE_UNSUBMITTED_ASSESSMENT, unsub_assess: unsub_assess } }
    function failure(error) { return { type: organisationConstants.ERROR_UNSUBMITTED_ASSESSMENT, error } }
}

function resetAssessmentAction(data) {
    return dispatch => {
        dispatch(request());
        return organisationService.resetAssessmentService({
            assessment_id: data.assessment_id,
            organisation_id: data.organisation_id,
            batch_id: data.batch_id
        })
        .then(
            reset_assessment => {
                dispatch(success(reset_assessment));
                dispatch(getAllotedUnallotedListAction({
                    data: {
                        batch_id: data.batch_id,
                        organisation_id: data.organisation_id
                    }
                }));
                // Return the success response
                return {
                    success: true,
                    message: reset_assessment.data.message || 'Assessment reset successfully'
                };
            },
            error => {
                dispatch(failure(error));
                // Return the error response with safer object access
                let errorMessage = 'Failed to reset assessment';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                return {
                    success: false,
                    message: errorMessage
                };
            }
        );
    };

    function request() { return { type: organisationConstants.REQUEST_RESET_ASSESSMENT } }
    function success(reset_assessment) { return { type: organisationConstants.RESPONSE_RESET_ASSESSMENT, reset_assessment } }
    function failure(error) { return { type: organisationConstants.ERROR_RESET_ASSESSMENT, error } }
}




function enableReportsAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.enableReports(data)
            .then(
                enable_report => {
                    dispatch(success(enable_report));
                    dispatch(getAllotedUnallotedListAction({
                        data: {
                            batch_id: data.batchId,
                            organisation_id: data.orgId
                        }
                    }))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_ENABLE_REPORT } }
    function success(enable_report) { return { type: organisationConstants.RESPONSE_ENABLE_REPORT, enable_report: enable_report } }
    function failure(error) { return { type: organisationConstants.ERROR_ENABLE_REPORT, error } }
}

function disableReportsAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.disableReports(data)
            .then(
                disable_report => {
                    dispatch(success(disable_report));
                    dispatch(getAllotedUnallotedListAction({
                        data: {
                            batch_id: data.batchId,
                            organisation_id: data.orgId
                        }
                    }))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_DISABLE_REPORT } }
    function success(disable_report) { return { type: organisationConstants.RESPONSE_DISABLE_REPORT, disable_report: disable_report } }
    function failure(error) { return { type: organisationConstants.ERROR_DISABLE_REPORT, error } }
}

function deleteReportsAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.deleteReports(data)
            .then(
                delete_report => {
                    dispatch(success(delete_report));
                    dispatch(getAllotedUnallotedListAction({
                        data: {
                            batch_id: data.batchId,
                            organisation_id: data.orgId
                        }
                    }))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_DELETE_REPORT } }
    function success(delete_report) { return { type: organisationConstants.RESPONSE_DELETE_REPORT, delete_report: delete_report } }
    function failure(error) { return { type: organisationConstants.ERROR_DELETE_REPORT, error } }
}

function setReportThemeAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.setReportTheme(data)
            .then(
                set_report_theme => {
                    dispatch(success(set_report_theme));
                    dispatch(getAllotedUnallotedListAction({
                        data: {
                            batch_id: data.batchId,
                            organisation_id: data.orgId
                        }
                    }))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_SET_REPORT_THEME } }
    function success(set_report_theme) { return { type: organisationConstants.RESPONSE_SET_REPORT_THEME, set_report_theme: set_report_theme } }
    function failure(error) { return { type: organisationConstants.ERROR_SET_REPORT_THEME, error } }
}

function getThemeReportAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.getThemeReport(data)
            .then(
                get_theme_report => {
                    dispatch(success(get_theme_report));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_GET_THEME_REPORT } }
    function success(get_theme_report) { return { type: organisationConstants.RESPONSE_GET_THEME_REPORT, get_theme_report: get_theme_report } }
    function failure(error) { return { type: organisationConstants.ERROR_GET_THEME_REPORT, error } }
}


function setDevelopmentAction(data) {

    return dispatch => {
        dispatch(request());
        organisationService.setDevPlan(data.data)
            .then(
                set_dev_plan => {
                    dispatch(success(set_dev_plan));
                    dispatch(getAllotedUnallotedListAction(data.getAllot))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    }

    function request() { return { type: organisationConstants.REQUEST_SET_DEV_PLAN } }
    function success(set_dev_plan) { return { type: organisationConstants.RESPONSE_SET_DEV_PLAN, set_dev_plan } }
    function failure(error) { return { type: organisationConstants.ERROR_SET_DEV_PLAN, error } }
}

function getCustomReportAction() {
    return dispatch => {
        dispatch(request());
        organisationService.getCustomReportService()
            .then(
                custom_report => {
                    dispatch(success(custom_report));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    }
    function request() { return { type: organisationConstants.REQUEST_GET_CUSTOM_REPORT } }
    function success(custom_report) { return { type: organisationConstants.RESPONSE_GET_CUSTOM_REPORT, custom_report } }
    function failure(error) { return { type: organisationConstants.ERROR_GET_CUSTOM_REPORT, error } }
}

function setReportCustom(data) {
    return dispatch => {
        dispatch(request());
        organisationService.setReportCustomService(data.data)
            .then(
                set_custom_report => {
                    dispatch(success(set_custom_report))
                    dispatch(getAllotedUnallotedListAction(data.get))
                },
                error => {
                    dispatch(failure(error))
                }
            )
    }
    function request() { return { type: organisationConstants.REQUEST_SET_CUSTOM_REPORT } }
    function success(set_custom_report) { return { type: organisationConstants.RESPONSE_SET_CUSTOM_REPORT, set_custom_report } }
    function failure(error) { return { type: organisationConstants.ERROR_SET_CUSTOM_REPORT, error } }
}

function addAnalyticsAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.addAnalyticsService(data.data)
            .then(
                add_analytics_org_admin => {
                    dispatch(success(add_analytics_org_admin))
                    dispatch(getAllotedUnallotedListAction(data.get))
                },
                error => {
                    dispatch(failure(error))
                }
            )
    }
    function request() { return { type: organisationConstants.REQUEST_ADD_ANALYTICS_ORG_ADMIN } }
    function success(add_analytics_org_admin) { return { type: organisationConstants.RESPONSE_ADD_ANALYTICS_ORG_ADMIN, add_analytics_org_admin } }
    function failure(error) { return { type: organisationConstants.ERROR_ADD_ANALYTICS_ORG_ADMIN, error } }
}

function removeAnalyticsAction(data) {
    return dispatch => {
        dispatch(request());
        organisationService.removeAnalyticsService(data.data)
            .then(
                remove_analytics_org_admin => {
                    dispatch(success(remove_analytics_org_admin))
                    dispatch(getAllotedUnallotedListAction(data.get))
                },
                error => {
                    dispatch(failure(error))
                }
            )
    }
    function request() { return { type: organisationConstants.REQUEST_REMOVE_ANALYTICS_ORG_ADMIN } }
    function success(remove_analytics_org_admin) { return { type: organisationConstants.RESPONSE_REMOVE_ANALYTICS_ORG_ADMIN, remove_analytics_org_admin } }
    function failure(error) { return { type: organisationConstants.ERROR_REMOVE_ANALYTICS_ORG_ADMIN, error } }
}

// function (data) {
//     return dispatch => {
//         dispatch(request());
//         organisationService.(data)
//             .then(
//                  => {
//                     dispatch(success());
//                 },
//                 error => {
//                     dispatch(failure(error));
//                 }
//             );
//     };

//     function request() { return { type: organisationConstants.} }
//     function success() { return { type: organisationConstants., :  } }
//     function failure(error) { return { type: organisationConstants., error } }
// }


// WEBPACK FOOTER //
// ./src/_actions/organisations/manageBatchList.action.js